import React from 'react';
import PropTypes from 'prop-types';
import { toggleItem } from '../../toggle';
import { Checkbox } from '../../atoms';
import {
  StyledCheckboxGroup,
  Headline,
  Instructions,
  Group,
} from './styles.js';

export const CheckboxGroup = ({
  name,
  headline,
  instructions,
  options,
  selected,
  onChange,
  className = '',
}) => {
  return (
    <StyledCheckboxGroup className={className}>
      <div>
        <Headline>{headline}</Headline>
        {instructions && <Instructions>{instructions}</Instructions>}
      </div>
      <Group>
        {options.map(option => {
          const checked = selected.includes(option.value);
          return (
            <Checkbox
              key={option.value}
              name={`${name}-${option.value}`}
              label={option.label}
              checked={checked}
              onChange={() => onChange(toggleItem(selected, option.value))}
            />
          );
        })}
      </Group>
    </StyledCheckboxGroup>
  );
};

CheckboxGroup.displayName = 'CheckboxGroup';

CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  instructions: PropTypes.node,
  options: PropTypes.array.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
